/* unplugin-vue-components disabled */import script from "./years.vue?vue&type=script&setup=true&lang=js"
export * from "./years.vue?vue&type=script&setup=true&lang=js"

import "./years.vue?vue&type=style&index=0&id=1b51da1b&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b51da1b"]])

export default __exports__